import type { OnChangeValue } from 'react-select';
import Creatable from 'react-select/creatable';

import { ChatTagProps } from '../../../../../features/communities/components/Chats/interface/chats.interface';

type Props = {
    readonly options: ChatTagProps[];
    readonly value: ChatTagProps[];
    readonly onChange: () => void;
};

export const TagsSelector = ({ options, value, onChange }: Props) => {
    const handleCreateTag = (currentValue: string): void => {
        onChange([...value, { name: currentValue }]);
    };

    const handleChange = (
        updateTags: OnChangeValue<{ label: string; value: string }, true>
    ): void => {
        onChange([...updateTags.map(v => v)]);
    };

    return (
        <Creatable
            isMulti
            onChange={handleChange}
            onCreateOption={handleCreateTag}
            options={mapTagsToOptions(options)}
            value={mapTagsToOptions(value)}
            placeholder='Название тега, до 50 знаков'
            noOptionsMessage={() => 'Пусто'}
            formatCreateLabel={inputValue => (
                <>
                    <b>Создать тег:</b> &laquo;{inputValue}&raquo;
                </>
            )}
        />
    );
};

const mapTagsToOptions = (tags: ChatTagProps[]) => {
    return tags.map(tag => ({ ...tag, label: tag.name, value: tag.name }));
};
